import React from "react";
function Footer() {
    return (
        <footer className="bg-gray-800 text-white p-5">
            <div className="flex justify-center">
                <p>© {new Date().getFullYear()} Cheche - All rights reserved</p>
            </div>
        </footer>
    );
}

export default Footer;